import mixpanel from "mixpanel-browser";
import { AnalyticsEventBus, event } from "../analytics";
import { prop } from ".";

export class PurchaseOrderAssetMixpanelHandlers {
  static handleAll() {
    this.handleViewEvents();
  }

  static handleViewEvents() {
    AnalyticsEventBus.$on(event.view.create_purchase_order_asset, (data) => {
      mixpanel.track(event.view.create_purchase_order_asset, {
        Language: prop.languages[data.language],
        document_template: data.document_template,
      });
    });
  }
}
